import { combineReducers } from 'redux'
import {
  VESSEL_PAGE_ERROR, VESSEL_PAGE_LOADING, VESSEL_LIST_SUCCESS,
  VESSEL_VIEW_SUCCESS, VESSEL_PAGE_SUCCESS, VESSEL_VIEW_ERROR,
  VESSEL_ADD_ERROR, VESSEL_ADD_LOADING, VESSEL_ADD_SUCCESS,
  VESSEL_VIEW_LOADING, VESSEL_DELETE_ERROR, VESSEL_DELETE_LOADING, 
  VESSEL_DELETE_SUCCESS, VESSEL_UPDATE_SUCCESS, VESSEL_UPDATE_ERROR, VESSEL_UPDATE_LOADING, VESSEL_LIST_ERROR, VESSEL_LIST_LOADING
} from './constant'

const vesselPageError = (state = false, action) => {
  switch (action.type) {
    case VESSEL_PAGE_ERROR:
      return action.vesselPageError
    default:
      return state
  }
}

const vesselPageLoading = (state = false, action) => {
  switch (action.type) {
    case VESSEL_PAGE_LOADING:
      return action.vesselPageLoading
    default:
      return state
  }
}

const vesselPageSuccess = (state = false, action) => {
  switch (action.type) {
    case VESSEL_PAGE_SUCCESS:
      return action.vesselPageSuccess
    default:
      return state
  }
}

const vessels = (state = [], action) => {
  switch (action.type) {
    case VESSEL_PAGE_SUCCESS:
      return action.vessel
    case VESSEL_LIST_SUCCESS:
      return action.vessel
    default:
      return state
  }
}

const vessel = (state = [], action) => {
  switch (action.type) {
    case VESSEL_VIEW_SUCCESS:
      return action.vessel
    default:
      return state
  }
}

const vesselAddError = (state = false, action) => {
  switch (action.type) {
    case VESSEL_ADD_ERROR:
      return action.vesselAddError
    default:
      return state
  }
}

const vesselAddLoading = (state = false, action) => {
  switch (action.type) {
    case VESSEL_ADD_LOADING:
      return action.vesselAddLoading
    default:
      return state
  }
}

const vesselAddSuccess = (state = false, action) => {
  switch (action.type) {
    case VESSEL_ADD_SUCCESS:
      return action.vesselAddSuccess
    default:
      return state
  }
}

const vesselViewError = (state = false, action) => {
  switch (action.type) {
    case VESSEL_VIEW_ERROR:
      return action.vesselViewError
    default:
      return state
  }
}

const vesselViewLoading = (state = false, action) => {
  switch (action.type) {
    case VESSEL_VIEW_LOADING:
      return action.vesselViewLoading
    default:
      return state
  }
}

const vesselViewSuccess = (state = false, action) => {
  switch (action.type) {
    case VESSEL_VIEW_SUCCESS:
      return action.vesselViewSuccess
    default:
      return state
  }
}

const vesselDeleteError = (state = false, action) => {
  switch (action.type) {
    case VESSEL_DELETE_ERROR:
      return action.vesselDeleteError
    default:
      return state
  }
}

const vesselDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case VESSEL_DELETE_LOADING:
      return action.vesselDeleteLoading
    default:
      return state
  }
}

const vesselDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case VESSEL_DELETE_SUCCESS:
      return action.vesselDeleteSuccess
    default:
      return state
  }
}

const vesselUpdateError = (state = false, action) => {
  switch (action.type) {
    case VESSEL_UPDATE_ERROR:
      return action.vesselUpdateError
    default:
      return state
  }
}

const vesselUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case VESSEL_UPDATE_LOADING:
      return action.vesselUpdateLoading
    default:
      return state
  }
}

const vesselUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case VESSEL_UPDATE_SUCCESS:
      return action.vesselUpdateSuccess
    default:
      return state
  }
}

const vesselListError = (state = false, action) => {
  switch (action.type) {
    case VESSEL_LIST_ERROR:
      return action.vesselListError
    default:
      return state
  }
}

const vesselListLoading = (state = false, action) => {
  switch (action.type) {
    case VESSEL_LIST_LOADING:
      return action.vesselListLoading
    default:
      return state
  }
}

const vesselListSuccess = (state = false, action) => {
  switch (action.type) {
    case VESSEL_LIST_SUCCESS:
      return action.vesselListSuccess
    default:
      return state
  }
}

const vesselReducer = combineReducers({
  vesselPageError,
  vesselPageLoading,
  vesselPageSuccess,

  vessels,
  vessel,

  vesselAddError,
  vesselAddLoading,
  vesselAddSuccess,

  vesselViewError,
  vesselViewLoading,
  vesselViewSuccess,

  vesselDeleteError,
  vesselDeleteLoading,
  vesselDeleteSuccess,

  vesselUpdateError,
  vesselUpdateLoading,
  vesselUpdateSuccess,

  vesselListError,
  vesselListLoading,
  vesselListSuccess,
})

export default vesselReducer
